<template>
    <div class='loading-full flex align-center'>
        <div class='tc'> 
            <icon icon="spinner" spin> </icon>
            <p> {{status}} </p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['status']
}
</script>

<style scoped lang="stylus">
    p{
        font-size:12px;
        max-width 450px;
    }
    .loading-full{
        position:fixed;
        top:0;left:0;right:0;bottom:0;
        background:rgba(black,0.4);
        z-index:10000;
        color: white;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size:44px
    }
        
</style>
